export type DeploymentEnv = "env7" | "uat" | "prod";

const PROD_UI_HOST = "agent-ui.tigerconnect.com";

const ENV_UI_HOSTS: Record<string, DeploymentEnv> = {
  "agent-ui.env7.tigerconnect.com": "env7",
  "agent-ui.uat.tigerconnect.com": "uat",
};

const AGENT_PATH = "/v1/agents/tiger_agent";

const GATEWAY_ORIGINS: Record<DeploymentEnv, string> = {
  env7: "https://agent.env7.tigerconnect.com",
  uat: "https://agent.uat.tigerconnect.com",
  prod: "https://agent.tigerconnect.com",
};

function deploymentEnv(hostname: string): DeploymentEnv | null {
  const host = hostname.toLowerCase();

  if (host === PROD_UI_HOST) return "prod";
  const customDomain = ENV_UI_HOSTS[host];
  if (customDomain) return customDomain;

  return null;
}

export function deriveAgentBaseUrl(hostname: string): string | null {
  const env = deploymentEnv(hostname);
  return env === null ? null : `${GATEWAY_ORIGINS[env]}${AGENT_PATH}`;
}

export function isProductionHost(hostname: string): boolean {
  return deploymentEnv(hostname) === "prod";
}
